<template>
    <div class="base-subscription-form">
        <div v-if="detail.data.subscriptionData">
            <account-summary
                :subscriptionData.sync="detail.data.subscriptionData.subscription"
                :userId="detail.data.userId"
                :customerType="customerType"
                :btnSubscriptionPlan.sync="btnSubscriptionPlan"
            />
            <current-bill-cycle
                :propsCurrentBillCycle.sync="detail.data.subscriptionData.currentBillCycle"
            />
        </div>
        <div v-else class="subscription-form-data-not-found">
            <p>ไม่พบข้อมูล Subscription ของบุคคลนี้</p>
        </div>
    </div>
</template>

<script>
import AccountSummary from '@/components/Customer/Subscription/AccountSummary'
import CurrentBillCycle from '@/components/Customer/Subscription/CurrentBillCycle'

export default {
    name: 'BaseSubscriptionForm',
    components: {
        AccountSummary,
        CurrentBillCycle
    },
    props: {
        detail: {
            type: Object,
            default: () => {}
        },
        customerType: {
            type: String,
            default: ''
        },
        btnSubscriptionPlan: {
            type: Object,
            default: () => {}
        }
    }
}
</script>

<style scoped>
.subscription-form-data-not-found{
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
